'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dropdownElement = require('./dropdownElement.html');

var _dropdownElement2 = _interopRequireDefault(_dropdownElement);

var _dropdownTemplate = require('./dropdownTemplate.html');

var _dropdownTemplate2 = _interopRequireDefault(_dropdownTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dropdown = {
  bindings: {
    title: '@',
    selection: '='
  },
  template: _dropdownElement2.default,
  controller: function controller($scope, $ionicPopover, ApiPicklist) {
    var _this = this;

    this.popover = $ionicPopover.fromTemplate(_dropdownTemplate2.default, { scope: $scope });

    this.$onInit = function () {
      var ctrl = _this;
      ApiPicklist.retrieveLevelsOfInterest().then(function (levelsOfInterest) {
        ctrl.options = levelsOfInterest.data;
      });
    };

    this.openPopover = function ($event) {
      _this.popover.show($event);
    };

    this.closePopover = function (option) {
      _this.selection = option.key;
      _this.selectedOption = option;
      _this.popover.hide();
    };

    //Cleanup the popover when we're done with it!
    $scope.$on('$destroy', function () {
      _this.popover.remove();
    });
  }
};

exports.default = dropdown;


/** WEBPACK FOOTER **
 ** ./src/app/directives/popovers/dropdown.js
 **/